// src/services/aeo/sampleActor.ts
//
// Who acts in the sample stores. Live, the server takes the person from the
// token; on the dev server the sample stores record the signed-in person's
// name, which the Oura shell sets here (useSignedInName in @oura/docs). A seed
// keeps the people it was written with. DELETE with the sample stores.

let actor: string | null = null;

/** The signed-in person's name, or null when the profile carries none. */
export function setSampleActor(name: string | null): void {
    actor = name?.trim() || null;
}

/** The name a sample write records: the signed-in person, else the seed's own. */
export function sampleActor(fallback: string): string {
    return actor ?? fallback;
}
